export function isDefinedAssertType<T>(p: T | undefined | null): p is T {
	return p !== null && p !== undefined;
}